@layer ui-kit;
@layer ui-kit {
  ._1v0ltdb0 {
    position: relative;
    justify-content: space-between;
    gap: 16px;
    height: 100%;
  }
  ._1v0ltdb1 {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    min-width: 0;
  }
  ._1v0ltdb2 {
    position: relative;
    display: block;
    width: 100%;
    height: 175px;
    overflow: hidden;
    flex-shrink: 0;
    border-radius: 8px;
    background-color: #000;
  }
  ._1v0ltdb2::after {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none;
    border-radius: inherit;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);
  }
  ._1v0ltdb3 {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  ._1v0ltdb4 {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    flex-wrap: wrap;
  }
  ._1v0ltdb5 {
    gap: 8px;
  }
  ._1v0ltdb6 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  ._1v0ltdb7 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  ._1v0ltdb8 {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    min-width: 0;
    padding: 12px;
    background-color: var(--_1iamlv42);
    box-shadow: inset 0 0 0 1px var(--_1iamlv4g);
    border-radius: 16px;
  }
  ._1v0ltdb9 {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    grid-template-rows: repeat(3, auto);
    grid-auto-flow: column;
    column-gap: 16px;
    row-gap: 8px;
    width: 100%;
    min-width: 0;
    margin: 0;
    padding: 0;
    list-style: none;
  }
  ._1v0ltdba {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }
  ._1v0ltdbb {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    border-radius: 8px;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);
    color: var(--_1iamlv4b);
  }
  ._1v0ltdbc {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    border-radius: 8px;
    color: var(--_1iamlv4d);
  }
  ._1v0ltdbb :where(svg), ._1v0ltdbc :where(svg) {
    width: 12px;
    height: 12px;
    flex-shrink: 0;
  }
  ._1v0ltdbd {
    font-weight: 400;
    font-size: 12px;
    line-height: 1.3;
    letter-spacing: -0.01em;
    color: var(--_1iamlv4b);
  }
  ._1v0ltdbe {
    font-weight: 400;
    font-size: 12px;
    line-height: 1.3;
    letter-spacing: -0.01em;
    color: var(--_1iamlv4d);
  }
  ._1v0ltdbf {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    flex-shrink: 0;
  }
}